import React, { useEffect, useState } from 'react';
import { X, Package, Users } from 'lucide-react';
import { Button } from 'react-bootstrap';
import CustomMultiSelect from '../CustomMultiSelect';

const TaskFilterBuilder = ({
  isOpen = false,
  onClose,
  serviceTypeOptions = [],
  serviceTypeValues = [],
  processorsOptions = [],
  processorsValues = [],
  onApplyFilters,
  isAccurateUser = false
}) => {
  const [localServiceTypes, setLocalServiceTypes] = useState(serviceTypeValues);
  const [localProcessors, setLocalProcessors] = useState(processorsValues);

  useEffect(() => {
    if (isOpen) {
      setLocalServiceTypes(serviceTypeValues);
      setLocalProcessors(processorsValues);
    }
  }, [isOpen, serviceTypeValues, processorsValues]);

  const handleClearAll = () => {
    setLocalServiceTypes([]);
    setLocalProcessors([]);
    onApplyFilters({
      serviceTypeValues: [],
      processorsValues: []
    });
  };

  const handleApply = () => {
    onApplyFilters({
      serviceTypeValues: localServiceTypes,
      processorsValues: localProcessors
    });
    onClose();
  };

  const handleServiceTypeChange = values => {
    setLocalServiceTypes(values.map(v => v.value));
  };

  const handleProcessorsChange = values => {
    setLocalProcessors(values.map(v => v.value));
  };

  return (
    <div
      className="mt-2 shadow-sm border bg-white"
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        minWidth: '500px',
        borderRadius: '8px',
        zIndex: 1000,
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center mb-2 border-bottom"
        style={{ padding: '12px 16px' }}
      >
        <h5 className="text-dark mb-0" style={{ fontSize: '15px', fontWeight: 600 }}>
          Filter Tasks
        </h5>
        <button
          onClick={onClose}
          className="pointer-cursor border-0 rounded-lg bg-transparent hover-muted d-flex align-items-center justify-content-center p-1"
        >
          <X size={16} />
        </button>
      </div>

      <div className="p-3 pb-0" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {/* Order Types Filter */}
        <div className="mb-3">
          <div className="d-flex align-items-center mb-2">
            <Package size={16} className="mr-2 text-muted" />
            <label className="mb-0 smallFont">
              Order Types
            </label>
          </div>
          <CustomMultiSelect
            className="filter-multi-select-input"
            id="serviceType"
            onChange={handleServiceTypeChange}
            selectedOptions={localServiceTypes}
            options={serviceTypeOptions.map(opt => ({ label: opt, value: opt }))}
            label=""
            placeholder="Select order types"
            menuPosition="fixed"
            maxToShow={2}
          />
        </div>

        {/* Assigned Processors Filter */}
        {isAccurateUser && (
          <div className="mb-3">
            <div className="d-flex align-items-center mb-2">
              <Users size={16} className="mr-2 text-muted" />
              <label className="mb-0 smallFont">
                Assigned Processors
              </label>
            </div>
            <CustomMultiSelect
              className="filter-multi-select-input"
              id="processors"
              onChange={handleProcessorsChange}
              selectedOptions={localProcessors}
              options={processorsOptions}
              label=""
              placeholder="Select processors"
              menuPosition="fixed"
              maxToShow={2}
            />
          </div>
        )}
      </div>

      <div className="d-flex justify-content-end align-items-center py-2 px-4 border-top" style={{ gap: '8px' }}>
        <Button
          variant="outline-secondary"
          onClick={handleClearAll}
          className="hover-muted bg-white shadow-none text-dark"
        >
          Clear all
        </Button>
        <Button
          variant="success"
          style={{ backgroundColor: '#FACC15', borderColor: '#FACC15', boxShadow: 'none', color: '#000' }}
          onClick={handleApply}
        >
          Apply filters
        </Button>
      </div>
    </div>
  );
};

export default TaskFilterBuilder;
